import {
    styled,
} from "@mui/material"

import { styledForMobile } from "../../utils/styledForMobile"

export const ScrollableLayoutContainer = styled("div")(() => ({
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "100%",
    minHeight: 0,
}))

export const ContentContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
    flex: "1 1 auto",
    overflowY: "auto",
    paddingTop: theme.spacing(2),
    minHeight: 0,
}))

export const ButtonsContainer = styledForMobile("div", ["showShadow"])(({ theme, showShadow, isMobile }) => ({
    backgroundColor: theme.palette["common/white_states"].main,
    margin: isMobile ? theme.spacing(0, -6, -6, -6) : theme.spacing(0, -8, -8, -8),
    padding: isMobile ? theme.spacing(6, 4, 4, 4) : theme.spacing(8),
    display: "flex",
    justifyContent: isMobile ? "space-around" : "right",
    gap: theme.spacing(5),
    boxShadow: showShadow ? "0 -1px 4px 0 rgba(0, 0, 0, 0.15)" : "none",
    zIndex: 1,

    "& > *": {
        flex: isMobile ? "1 1 auto" : "0 0 auto",
    },
}))
